import moment from "moment";
import {
  ARRIVAL_DROPDOWN_HANDLER,
  CITY_DROPDOWN_HANDLER,
  CLOSE_ALL_DROPDOWN,
  DECREASE_ADULTS,
  DECREASE_PETS,
  DEPARTURE_DROPDOWN_HANDLER,
  INCREASE_ADULTS,
  INCREASE_CHILDREN,
  INCREASE_PETS,
  PERSON_DROPDOWN_HANDLER,
  SET_CHILD_AGE,
  SET_ACTIVE_PROPERTY_ID,
  SET_ARRIVAL_DATE,
  SET_DEPARTURE_DATE,
  SET_IS_ARRIVAL,
  SET_IS_BLOCK_VIEW,
  SET_IS_CITY_DROPDOWN,
  SET_IS_DEPARTURE,
  SET_IS_ERROR_DATE,
  SET_IS_MOBLE_OPEN,
  SET_IS_PERSON_DROPDOWN,
  SET_PAGE_NUMBER,
  SET_SELECTED_CITY,
  SET_SELECTED_PROPERTY,
  SET_TYPES,
  DECREASE_CHILDREN,
} from "../_actions/types";

const initialState = {
  // Adults and every child with its age (null until chosen). `chosen` turns
  // on with the first change, until then the search uses one adult.
  persons: {
    adults: 1,
    children: [],
    pets: 0,
    chosen: false,
  },
  isBlockView: true,
  isCityDropdownActive: false,
  isPersonDropdownActive: false,
  mobileMenuOpen: false,
  isArrival: false,
  isDeparture: false,
  errorDate: false,
  arrivalDate: null,
  departureDate: null,
  activePropertyId: null,
  selectedProperty: null,
  cities: [],
  selectedCity: "",
  pageNumber: 1,
  types: [],
};

const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case INCREASE_ADULTS:
      return {
        ...state,
        persons: { ...state.persons, adults: state.persons.adults + 1, chosen: true },
      };
    case DECREASE_ADULTS:
      return {
        ...state,
        persons: {
          ...state.persons,
          adults: Math.max(1, state.persons.adults - 1),
          chosen: true,
        },
      };
    case INCREASE_CHILDREN:
      return {
        ...state,
        persons: {
          ...state.persons,
          children: [...state.persons.children, { id: action.payload.id, age: null }],
          chosen: true,
        },
      };
    case DECREASE_CHILDREN:
      return {
        ...state,
        persons: {
          ...state.persons,
          children: state.persons.children.slice(0, -1),
          chosen: true,
        },
      };
    case SET_CHILD_AGE:
      return {
        ...state,
        persons: {
          ...state.persons,
          children: state.persons.children.map((child) =>
            child.id === action.payload.id ? { ...child, age: action.payload.age } : child
          ),
        },
      };
    case INCREASE_PETS:
      return {
        ...state,
        persons: { ...state.persons, pets: state.persons.pets + 1 },
      };
    case DECREASE_PETS:
      return {
        ...state,
        persons: { ...state.persons, pets: Math.max(0, state.persons.pets - 1) },
      };
    case SET_IS_BLOCK_VIEW:
      return { ...state, isBlockView: action.payload };
    case SET_IS_CITY_DROPDOWN:
      return { ...state, isCityDropdownActive: action.payload };

    case SET_IS_PERSON_DROPDOWN:
      return { ...state, isPersonDropdownActive: action.payload };
    case SET_IS_MOBLE_OPEN:
      return { ...state, mobileMenuOpen: action.payload };
    case SET_IS_ARRIVAL:
      return { ...state, isArrival: action.payload };
    case SET_IS_DEPARTURE:
      return { ...state, isDeparture: action.payload };

    case SET_ARRIVAL_DATE:
      return { ...state, arrivalDate: action.payload };

    case SET_DEPARTURE_DATE:
      return { ...state, departureDate: action.payload };

    case SET_IS_ERROR_DATE:
      return { ...state, errorDate: action.payload };
    case SET_ACTIVE_PROPERTY_ID:
      return { ...state, activePropertyId: action.payload };
    case SET_SELECTED_PROPERTY:
      return { ...state, selectedProperty: action.payload };
    // case SET_CITIES:
    //   return { ...state, cities: action.payload }
    case SET_SELECTED_CITY:
      return { ...state, selectedCity: action.payload };
    case SET_PAGE_NUMBER:
      return { ...state, pageNumber: action.payload };

    case SET_TYPES:
      const newTypes = state.types.map((type) =>
        type.id === action.payload
          ? { ...type, isSelected: !type.isSelected }
          : type
      );
      return { ...state, types: newTypes };

    case ARRIVAL_DROPDOWN_HANDLER:
      return {
        ...state,
        isArrival: true,
        isDeparture: false,
        isCityDropdownActive: false,
        isPersonDropdownActive: false,
      };
    case DEPARTURE_DROPDOWN_HANDLER:
      return {
        ...state,
        isArrival: false,
        isDeparture: true,
        isCityDropdownActive: false,
        isPersonDropdownActive: false,
      };
    case CITY_DROPDOWN_HANDLER:
      return {
        ...state,
        isArrival: false,
        isDeparture: false,
        isCityDropdownActive: true,
        isPersonDropdownActive: false,
      };
    case PERSON_DROPDOWN_HANDLER:
      return {
        ...state,
        isArrival: false,
        isDeparture: false,
        isCityDropdownActive: false,
        isPersonDropdownActive: !state.isPersonDropdownActive,
      };
    case CLOSE_ALL_DROPDOWN:
      return {
        ...state,
        isArrival: false,
        isDeparture: false,
        isCityDropdownActive: false,
        isPersonDropdownActive: false,
      };
    default:
      return state;
  }
};

export default searchReducer;
